import { Modal } from "reactstrap";
import styles from "./NewUserModal.module.scss";
import { User } from "../../../interfaces/interfaces";
import { HiTrash } from "react-icons/hi";
import { RiCloseFill } from "react-icons/ri";
import { useDebugValue, useEffect, useState } from "react";
import { digitsOnly, getLocalUser, removeSpace } from "../../../components/functions/utilities";
import { RestS } from "../../../rest/rest-service";
import { UsersRestS } from "../../../rest/users-rest-service";
import { EditProfileInput } from "./EditProfileModal";
import { AiFillCheckCircle, AiFillInfoCircle } from "react-icons/ai";
import WorkspaceSelectTable from "./WorkspaceSelectTable";
import ConfirmDialog from "../../../components/common/ConfirmDialog";
import ConfirmDialog2 from "../../../components/common/ConfirmDialog2/ConfirmDialog2";
import useModal from "../../../components/Hooks/useModal";
import { mobileNumberValidationDis } from "../../../components/functions/formValidation";
import MeritoButton from "../../../components/common/MeritoButtons/MeritoButtons";

type Props = {
  toggle: () => void;
  visible: boolean;
  getUserData: () => void;
};

// const initialFields = {
//   name: "",
//   designation: "",
//   email: "",
//   role: getLocalUser()?.role ? getLocalUser()?.role : "Admin",
//   phoneNumber: "",
//   companyName: "",
//   phoneCode: "+91"
// };

// console.log('initialFields', initialFields)


const initialErrors = {
  email: "",
  designation: "",
  name: "",
  phoneNumber: "",
  companyName: "",
  common: "",
};

export const allowOnlyNumberPlus = (value) => {
  //
  const re = /^[+0-9\b]+$/;

  // if value is not blank, then test the regex

  if (value === "" || re.test(value)) {
    return true;
  } else {
    return false;
  }
};

export const allowOnlyNumber = (value) => {
  //
  const re = /^[0-9\b]+$/;

  // if value is not blank, then test the regex

  if (value === "" || re.test(value)) {
    return true;
  } else {
    return false;
  }
};


const NewUserModal = ({ visible, toggle, getUserData }: Props) => {
  const initialFields = {
    name: "",
    designation: "",
    email: "",
    role: getLocalUser()?.role ? getLocalUser()?.role : "Admin",
    phoneNumber: "",
    companyName: "",
    phoneCode: "+91",
    whatsappReport: 0
  };


  const [fields, setFields] = useState(initialFields);
  const [updateDisable, setUpdateDisable] = useState(true);
  const [step, setStep] = useState(0);
  const [count, setCount] = useState(0);
  const [error, setError] = useState(initialErrors);
  const { toggle: skipToggle, visible: skipVisible } = useModal();
  const { toggle: setToggle, visible: setVisible } = useModal();
  const [reportIds, setReportIds] = useState(new Set());

  const currUser = getLocalUser();
  const [inviteMessage, setInviteMessage] = useState({
    title: "",
    subTitle: "",
  });

  console.log('initialFields inside component', initialFields)

  const elements = [
    {
      title: "Add Team Member",
      subTitle: "",
      midBtn: "Cancel",
      leftBtn: true,
    },
    currUser?.role == "Agency" ?
      {
        title: "Brand Access",
        subTitle: "",
        midBtn: "Skip",
        leftBtn: true,
      }
      : {
        title: "Add to Workspaces",
        subTitle: "Add the user to workspaces",
        midBtn: "Skip",
        leftBtn: true,
        showSkipToggle: true
      },
  ];

  const companyValidation = () => {
    if (fields["role"] != "Agency") return true;
    if (currUser["role"] == "Agency") return true;
    if (fields["role"] == "Agency") {
      if (fields["companyName"] == "") {
        return false;
      } else return true;
    }
  };

  const validate = (label) => {
    if (count < 3) {
      setCount((prev) => prev + 1);
      return;
    }
    let pattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,15}$/g;
    let errors = {};
    errors["email"] = !fields["email"]
      ? "Required Field"
      : !pattern.test(fields["email"])
        ? "Please enter valid email ID"
        : "";
    errors["name"] = fields["name"] == "" ? "Required Field" : "";
    errors["companyName"] =
      fields["role"] == "Agency"
        ? fields["companyName"] == ""
          ? "Required Field"
          : ""
        : "";
    setError((prev) => {
      return {
        ...prev,
        [label]: errors[label],
      };
    });
    if (errors["email"] == "" && errors["name"] == "" && companyValidation())
      setUpdateDisable(false);
    else setUpdateDisable(true);
  };

  useEffect(() => {
    validate("name");
  }, [fields.name]);

  useEffect(() => {
    validate("email");
  }, [fields.email]);

  useEffect(() => {
    validate("companyName");
  }, [fields.companyName, fields.role]);

  const handleChange = (label, value) => {
    setFields((prev) => {
      return {
        ...prev,
        [label]: value,
      };
    });
  };

  const inviteUser = () => {
    if (currUser["role"] != "Agency" && fields["role"] != "Agency") {
      UsersRestS.newUser(fields as any, [...reportIds]).then(() => {
        getUserData();
      });
    } else if (currUser["role"] != "Agency" && fields["role"] == "Agency") {
      RestS.clientInvitingAgency(fields as any, [...reportIds]).then(() => {
        getUserData();
      });
    } else {
      // Agency user invite
      console.log(fields);
      UsersRestS.newUser(fields as any, [], [...reportIds]).then(() => {
        getUserData();
      });
    }
  };



  const inputEle = [
    {
      field: "name",
      label: "Name*",
      disabled: false,
      placeholder: "Enter Name",
      setValue: (e) => {
        handleChange("name", e.target.value);
      },
      value: fields.name,
      maxLength: 60,
    },
    {
      field: "email",
      label: "Email*",
      disabled: false,
      placeholder: "Enter Email Address",
      setValue: (e) => {
        handleChange("email", e.target.value);
      },
      value: fields.email,
      maxLength: 60,
    },
    {
      field: "designation",
      label: "Designation",
      disabled: false,
      placeholder: "Enter designation",
      setValue: (e) => {
        handleChange("designation", e.target.value);
      },
      value: fields.designation,
      maxLength: 60,
    },
    {
      field: "phoneNumber",
      label: "Phone Number",
      disabled: false,
      placeholder: "Enter phone number",
      setValue: {
        phoneCode: (e) => {
          const sanitizedValue = removeSpace(e.target.value);
          if (allowOnlyNumberPlus(sanitizedValue)) {
            handleChange("phoneCode", sanitizedValue);
          }
        },
        phoneNumber: (e) => {
          const sanitizedValue = digitsOnly(e.target.value);
          if (allowOnlyNumber(sanitizedValue)) {
            handleChange("phoneNumber", sanitizedValue);
          }
        }
      },
      value: {
        phoneCode: fields.phoneCode,
        phoneNumber: fields.phoneNumber
      },
      maxLength: {
        phoneCode: 4,
        phoneNumber: 15
      },
    },
  ];

  const close = () => {
    setError(initialErrors);
    setFields(initialFields);
    setUpdateDisable(true);
    setStep(0);
    setCount(0);
    setReportIds(new Set([]));
    toggle();
  };


  return (
    <>
      <Modal
        size="md"
        centered
        isOpen={visible}
        toggle={() => {
          close();
        }}
      >
        {
          <>
            <div className={styles.cont1}>
              <div className={styles.header}>
                <div className={styles.leftCont}>
                  <h1>{elements[step].title}</h1>
                  <p>{elements[step].subTitle}</p>
                </div>
                <div>
                  <RiCloseFill
                    className={styles.crossBtn}
                    onClick={() => {
                      close();
                    }}
                  />
                </div>
              </div>
              <div className={styles.stepper}>
                {step == 0 ? (
                  <div className={step == 0 ? styles.active : styles.complete}>
                    <div>
                      <p>1</p>
                    </div>
                  </div>
                ) : (
                  <AiFillCheckCircle />
                )}
                <p style={{ color: step == 1 ? "#1a9c36" : "#100828" }}>
                  User Details
                </p>
                <hr style={{ color: step == 1 ? "#1a9c36" : "#100828" }}></hr>
                <div className={step == 1 ? styles.active : styles.inactive}>
                  <div>
                    <p>2</p>
                  </div>
                </div>
                <p>{currUser?.role == "Agency" ? "Brand Access" : "Add to Workspaces"}</p>
              </div>
              {step == 0 ? (
                <div className={styles.body}>
                  {inputEle.map((ele) => {
                    return (
                      <EditProfileInput
                        label={ele.label}
                        maxLength={ele.maxLength}
                        placeholder={ele.placeholder}
                        value={ele.value}
                        setValue={ele.setValue}
                        disabled={ele.disabled}
                        message={error[ele.field]}
                      />
                    );
                  })}
                  <div className={styles.whatsAppReport}>
                    <input
                      type="checkbox"
                      disabled={!mobileNumberValidationDis(fields.phoneNumber)}
                      value={fields.whatsappReport}
                      onChange={(e) => {
                        handleChange("whatsappReport", e.target.checked ? 1 : 0);
                      }}
                      className={`${!mobileNumberValidationDis(fields.phoneNumber) ? styles.disabled : ''}`}
                    />
                    <div className={styles.whatsAppReportText}>
                      Receive communication from Merito on WhatsApp
                    </div>
                  </div>
                  {
                    currUser?.role == "Agency" ?
                      null :
                      <div className={styles.editInputEle}>
                        <p>User Type</p>
                        <select
                          disabled={false}
                          value={fields.role}
                          onChange={(e) => {
                            handleChange("role", e.target.value);
                          }}
                        >
                          <option>Admin</option>
                          <option>User</option>
                          <option>Agency</option>
                        </select>
                      </div>
                  }
                  {fields["role"] == "Agency" &&
                    currUser["role"] != "Agency" ? (
                    <EditProfileInput
                      label="Company Name"
                      maxLength={60}
                      placeholder="Enter Company Name"
                      value={fields.companyName}
                      setValue={(e) =>
                        handleChange("companyName", e.target.value)
                      }
                      disabled={false}
                      message={error["companyName"]}
                    />
                  ) : null}
                  <p
                    style={{
                      visibility: error["common"] == "" ? "hidden" : "visible",
                      padding: "12px",
                    }}
                    className={styles.error}
                  >
                    {error["common"]}
                  </p>
                </div>
              ) : (
                <div style={{ padding: "10px" }}>
                  <WorkspaceSelectTable
                    reportIds={reportIds}
                    setReportIds={setReportIds}
                  />
                </div>
              )}
            </div>
            <div className={styles.footer}>
              <div className={styles.footerLeft}>
                {elements[step]["leftBtn"] ? (
                  <MeritoButton
                    type="tertiary"
                    size="md"
                    btnText={elements[step]["midBtn"]}
                    onClick={() => {
                      // Handling Skip Button for adding workspaces
                      if (elements[step]["showSkipToggle"]) {
                        skipToggle();
                        return;
                      }
                      // Handling Cancel Button
                      if (step == 0) close();
                      // Handling Back Button
                      else setStep(0);
                    }}
                  />
                ) : null}
              </div>
              <div className={styles.footerRight}>
                <MeritoButton
                  type="primary-1"
                  size="md"
                  btnText={step == 0 ? "Next" : "Send Invite"}
                  disabled={updateDisable}
                  onClick={async () => {
                    if (!updateDisable) {
                      // Check if user is already added
                      var flag = true;
                      let errorTemp: any = {};
                      if (
                        fields["role"] == "Agency" &&
                        currUser?.role !== "Agency"
                      ) {
                        await UsersRestS.verifyAgencyDetails(
                          fields as any
                        ).catch((err) => {
                          flag = false;
                          setError({
                            ...errorTemp,
                            [err.field == null ? "common" : err.field]:
                              err.message,
                          });
                        });
                      } else {
                        await UsersRestS.verifyUserEmail(fields as any).catch(
                          (err) => {
                            flag = false;
                            errorTemp = {
                              ...error,
                              [err.field]: err.message,
                            };
                            setError(errorTemp);
                          }
                        );
                      }
                      if (flag) {
                        console.log("adasd", flag);
                        setStep(1);
                      }
                    }
                    if (step == 1) {
                      // send invite api call
                      setInviteMessage({
                        title: `${fields.name} has been invited!`,
                        subTitle: `When ${fields.name} signs in to Merito, they will see the workspaces that you've added them to.`,
                      });
                      close();
                      inviteUser();
                      setToggle();
                    }
                  }}
                />
              </div>
            </div>
          </>
        }
      </Modal>
      <ConfirmDialog2
        visible={skipVisible}
        toggle={skipToggle}
        size="md"
        title={"Skip the process?"}
        subTitle={
          "You would have to assign the workspaces to the user manually later."
        }
        activeBtnClick={() => {
          skipToggle()
        }}
        showCloseBtn={false}
        activeBtn="Assign now"
        backBtn="I’ll add them later"
        backUnderline={true}
        backBtnClick={() => {
          // send invite api call
          setInviteMessage({
            title: `${fields.name} has been invited!`,
            subTitle: ``,
          });
          close();
          inviteUser();
          skipToggle();
          setToggle();
        }}
      >
        <AiFillInfoCircle className={styles.iconPopup} />
      </ConfirmDialog2>
      <ConfirmDialog2
        visible={setVisible}
        toggle={() => {
          setInviteMessage({ title: "", subTitle: "" });
          setToggle();
        }}
        size="md"
        title={inviteMessage.title}
        subTitle={inviteMessage.subTitle}
        activeBtnClick={() => setToggle()}
        showCloseBtn={false}
        activeBtn="Got it"
        showBackButton={false}
      >
        <AiFillCheckCircle className={styles.iconPopup} />
      </ConfirmDialog2>
    </>
  );
};

export default NewUserModal;
